import Vue from 'vue';
import Router from 'vue-router';
//import Top from '../Top.vue';
import Dashboard from '../Dashboard.vue';
import NoticeList from '../NoticeList.vue';
import CounselingList from '../CounselingList.vue';
import CounselingDetail from '../CounselingDetail.vue';
import CounselingDetailCreate from '../CounselingDetailCreate.vue';
import Profile from '../Profile.vue';
import ProfileSetting from '../ProfileSetting.vue';
import Timeline from '../Timeline.vue';
import Terms from '../Terms.vue';
import Privacy from '../Privacy.vue';
import Law from '../Law.vue';
import Admin from '../Admin.vue';
import AdminUserList from '../AdminUserList.vue';
import AdminAdviserList from '../AdminAdviserList.vue';
import AdminCounselingList from '../AdminCounselingList.vue';
import AdminCounselingReplyList from '../AdminCounselingReplyList.vue';
import AdminInsight from '../AdminInsight.vue';
import NotFound from '../NotFound.vue';
import Payment from '../Payment.vue';
import PaymentComplete from '../PaymentComplete.vue';
import Consent from '../Consent.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
 /*
    {
      path: '/',
      name: 'top',
      component: Top
    },
*/    
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/noticeList',
      name: 'noticeList',
      component: NoticeList
    },
    {
      path: '/counselingList',
      name: 'counselingList',
      component: CounselingList
    },
    {
      path: '/counselingDetail',
      name: 'counselingDetail',
      component: CounselingDetailCreate
    },
    {
      path: '/counselingDetail/:counselingTopicsId',
      name: 'counselingDetail',
      component: CounselingDetail
    },
    {
      path: '/profile/:userId',
      name: 'profile',
      component: Profile
    },
    {
      path: '/profileSetting',
      name: 'profileSetting',
      component: ProfileSetting
    },
    {
      path: '/timeline',
      name: 'timeline',
      component: Timeline
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/law',
      name: 'law',
      component: Law
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    },
    {
      path: '/admin/userList',
      name: 'adminUserList',
      component: AdminUserList
    },
    {
      path: '/admin/adviserList',
      name: 'adminAdviserList',
      component: AdminAdviserList
    },
    {
      path: '/admin/counselingList',
      name: 'adminCounselingList',
      component: AdminCounselingList
    },
    {
      path: '/admin/counselingReplyList',
      name: 'adminCounselingReplyList',
      component: AdminCounselingReplyList
    },
    {
      path: '/admin/insight',
      name: 'adminInsight',
      component: AdminInsight
    },
    { path: '*',
      name: 'notfound',
      component: NotFound 
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment
    },
    {
      path: '/paymentComplete',
      name: 'paymentComplete',
      component: PaymentComplete
    },
    {
      path: '/consent',
      name: 'Consent',
      component: Consent
    },
  ]
});
